import { useSelector } from "react-redux";
import "./VisitorsOnSite.css"; 

const SiteVisitorsTable = () => {


    // Fetch the sites data from Redux
    const sites = useSelector((state) => state.dashboard.data.sites || []);



    return (
        <div className="site-visitors-container">
            <h2 className="table-heading">Total Visitors Per Site</h2>
            <div className="table-wrapper">
                <table className="site-visitors-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Site Name</th>
                            <th>Total Visitors</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sites && sites.length > 0 ? (
                            sites.map((site, index) => (
                                <tr key={site.id}>
                                    <td>{index + 1}</td>
                                    <td>{site.sitename}</td>
                                    <td>{site.totalVisitors}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="3" className="no-data">No data available</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SiteVisitorsTable;
